import React from "react"

import { PrimaryText } from "@front-shared/elements/primaryText.element"

import { INTEGRATIONS_CONFIG } from "../../../config/integrations.config"
import type { RawEraUploadCsvRowDTO } from "../../../dto/rawEraUploadCsvRow.dto"
import { EraUploadHelper } from "../../../helpers/eraUpload.helper"

export const EraUploadTableRowComponent: React.FunctionComponent<
    IEraUploadTableRowComponentProps
> = props => {
    return (
        <div className={`flex group relative ${props.className ?? ""}`}>
            <div className="table-row w-full">
                <div
                    className={`
                        min-h-[55px] px-[16px] flex items-center gap-[16px]
                        hover:bg-brand-whitePurple
                        ${!props.isLast ? "border-b border-solid border-brand-warmLight" : ""}
                    `}
                >
                    {Object.entries(
                        INTEGRATIONS_CONFIG.eraUpload
                            .ruleDisplayTableColumnMapping,
                    ).map(([key, columnConfig]) => (
                        <PrimaryText
                            key={key}
                            className={`
                                flex-shrink-0
                                ${columnConfig.tableWidthClassName || "w-[150px]"}
                                ${columnConfig.tableCellTruncate ? "truncate" : ""}
                            `}
                        >
                            {EraUploadHelper.getRowDisplayValue(
                                columnConfig,
                                props.row,
                            ) || "—"}
                        </PrimaryText>
                    ))}
                </div>
            </div>
        </div>
    )
}

interface IEraUploadTableRowComponentProps {
    className?: string
    row: RawEraUploadCsvRowDTO
    isLast?: boolean
}
